/**
 * Build-time feature flag for the design-doc loader rollout (LOADER-V2).
 *
 * Additive + inert by default: while OFF, every loading surface renders EXACTLY
 * what it renders today (the old CustomLoader spinner / the block-centred
 * BrandWheelLoader `page` variant), so behaviour is byte-identical. While ON, the
 * full-page loaders swap to the always-screen-centred, large `fullpage` variant
 * (design-doc variant A) and the AI-generation inline indicator swaps to the thin
 * line-art variant (design-doc variant B).
 *
 * The BrandWheelLoader component itself is NOT gated — its new `variant="fullpage"`
 * and `lineArt` props are additive and backward-compatible; only the call-site
 * SWAPS are gated here so the change is reviewable and revertible per environment.
 * Mirrors the repo's other featureFlag.js modules. Flip per environment via the
 * REACT_APP_* build var; at merge this can fold into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const LOADER_V2_ENABLED = truthy(process.env.REACT_APP_LOADER_V2);

export default LOADER_V2_ENABLED;
